export default __webpack_public_path__ + "static/media/Phillips.ceb77031.jpg";